import React from "react";
import { motion } from "framer-motion";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/qe2fnlnw_WhatsApp%20Image%202026-06-24%20at%2011.52.53%20AM%20%281%29.jpeg";

const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 lg:py-40 bg-cream"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 lg:gap-16">
                    <div className="col-span-12 lg:col-span-3">
                        <div className="section-number">01 / Biography</div>
                        <div className="mt-6 divider" />
                        <div className="mt-4 eyebrow">The Founder</div>
                    </div>

                    <div className="col-span-12 lg:col-span-9">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink-900 max-w-4xl"
                        >
                            A physician who chose to <em className="text-bisleri">measure success
                            in lives reached</em>, not paychecks earned.
                        </motion.h2>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-8 lg:gap-16 mt-16 md:mt-24">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                        className="col-span-12 lg:col-span-5"
                    >
                        <div className="relative overflow-hidden border border-ink-900/10 bg-bisleri-light">
                            <img
                                src={PORTRAIT}
                                alt="Dr. Rahul Ghule"
                                className="w-full h-[520px] md:h-[640px] object-cover object-top hover:scale-[1.03] transition-transform duration-700"
                            />
                            <div className="absolute top-5 left-5 inline-flex items-center gap-2 px-3 py-1 bg-white/95 backdrop-blur-sm border border-bisleri/20">
                                <span className="w-2 h-2 rounded-full bg-clinicgreen animate-pulse" />
                                <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-bisleri">
                                    CEO &amp; Founder
                                </span>
                            </div>
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-bisleri/95 to-transparent p-5 pt-16">
                                <div className="font-display italic text-2xl text-white">
                                    Dr. Rahul Ghule
                                </div>
                                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/80 mt-1">
                                    MBBS · KEM Mumbai
                                </div>
                            </div>
                        </div>

                        <div className="mt-5 eyebrow text-ink-500">
                            ↳ CEO &amp; Founder, Magicdil Group of Companies
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 1.1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                        className="col-span-12 lg:col-span-7 lg:pl-8"
                    >
                        <p className="drop-cap font-body text-lg md:text-xl leading-[1.7] text-ink-800">
                            Born and trained in Mumbai, Dr. Rahul Ghule completed his MBBS
                            at the prestigious KEM Hospital — one of India's foremost medical
                            institutions. But where most of his peers turned toward private
                            practice and corporate hospitals, he turned toward the railway
                            platforms of his own city. There, in 2017, he opened the first
                            <span className="text-bisleri font-semibold"> One Rupee Clinic</span> — a single
                            consultation, a single rupee, no questions asked.
                        </p>

                        <p className="font-body text-base md:text-lg leading-[1.8] text-ink-700 mt-6">
                            What began as a modest stall on a Mumbai station today serves more
                            than a million patients, operates 33 Emergency Medical Rooms across
                            Central and Western Railways, manages 2,800+ hospital beds across
                            13 facilities, and is the parent body of the
                            <em className="text-ink-900 font-semibold"> Magicdil Group of Companies</em> —
                            a healthcare ecosystem that includes Kamal Pharma, Kamal Pathology Lab,
                            Kamal Hospital, Kamal CT Scan Centre, Kamal Ambulance Service, and
                            Swasthyamrut Ayurvedic Centre.
                        </p>

                        <p className="font-body text-base md:text-lg leading-[1.8] text-ink-700 mt-6">
                            Recognised by <em className="text-ink-900">Times</em> as a Global
                            Indian Physician (2021), honoured at the Lokmat Health Awards
                            (2022), and decorated with an official letter of appreciation
                            from Central Railway, Dr. Ghule's name has become synonymous with
                            a single, stubborn idea: that quality healthcare is a right —
                            not a privilege earned by birth or income.
                        </p>

                        <div className="mt-12 grid grid-cols-2 gap-6 md:gap-8 border-t border-ink-900/10 pt-8">
                            {[
                                ["Medical Degree", "MBBS, KEM Hospital · Mumbai"],
                                ["Role", "CEO & Founder, Magicdil Group"],
                                ["Founding Venture", "One Rupee Clinic"],
                                ["Recognition", "Global Indian Physician — Times, 2021"],
                            ].map(([label, value]) => (
                                <div key={label} data-testid={`credential-${label.replace(/\s+/g, "-").toLowerCase()}`}>
                                    <div className="eyebrow mb-2">{label}</div>
                                    <div className="font-display text-lg md:text-xl text-ink-900">
                                        {value}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default About;
